// Business phone numbers are stored as E.164 (e.g. "+16475545504") — correct
// for `tel:` links, but not what you want to show a customer reading the
// page. This formats it for display only; storage format is untouched.
import { formatPhoneNumberIntl } from "react-phone-number-input";

export function displayPhone(value) {
  if (!value) return value;
  return formatPhoneNumberIntl(value) || value;
}
